<template>
<div class="course-obj section-holder">
    <div class="container">
         <div class="row">
            <div class="col-lg-4">
               <div class="card">
                  <div class="text-center card-icon">?</div>
                     <h6 class="pb-2">Why should I take up this course?</h6>
                     <p>By the end of the course, you will be able to 
                        sketchuser interfaces, user flows, ui animations
                        and storyboards.
                     </p>
                     <p>By the end of the course, you will be able to 
                        sketchuser interfaces, user flows, ui animations
                        and storyboards.
                     </p>
                     <p>By the end of the course, you will be able to 
                        sketchuser interfaces, user flows, ui animations
                        and storyboards.
                     </p>
               </div>
            </div>
            <div class="col-lg-4">
               <div class="card">
                    <div class="text-center card-icon">:O</div>
                     <h6 class="pb-2">What will I learn?</h6>
                     <p>By the end of the course, you will be able to 
                        sketchuser interfaces, user flows, ui animations
                        and storyboards.
                     </p>
                     <p>By the end of the course, you will be able to 
                        sketchuser interfaces, user flows, ui animations
                        and storyboards.
                     </p>
                     <p>By the end of the course, you will be able to 
                        sketchuser interfaces, user flows, ui animations
                        and storyboards.
                     </p>
                </div>
            </div>
            <div class="col-lg-4">
               <div class="card">
                   <div class="text-center card-icon">!</div>
                     <h6 class="pb-2">How will this course benefit me?</h6>
                     <p>By the end of the course, you will be able to 
                        sketchuser interfaces, user flows, ui animations
                        and storyboards.
                     </p>
                     <p>By the end of the course, you will be able to 
                        sketchuser interfaces, user flows, ui animations
                        and storyboards.
                     </p>
                     <p>By the end of the course, you will be able to 
                        sketchuser interfaces, user flows, ui animations
                        and storyboards.
                     </p>
                </div>
            </div>
         </div>
      </div>
</div>
</template>

<script>
export default {
  name: 'courseObjectives',
  data () {
    return {
    }
  }
}
</script>
<style lang="scss">
.course-obj{
    .card{
        border-radius: 3px;
        box-shadow: 0px 5px 15px rgba(0, 0, 0, 0.18);
        border: none;
        background-color: #fff;
        transition: box-shadow .25s;
        margin-bottom:40px;
        padding:30px;
        h6{color:#333; font-weight: 600; font-size:16px;}
        .card-icon{font-size:40px;  color:darken(#37b0ef,20%); padding:20px 0 40px 0;}
        p{font-size:12px; color:#555;}
        &:hover {
            transition: box-shadow .45s;
            box-shadow: 0px 15px 25px rgba(0, 0, 0, .25);
            opacity: 1;
        } 
    }
}
</style>



// WEBPACK FOOTER //
// src/components/course/courseObjectives.vue?0066fb67